module.exports = __webpack_public_path__ + "img/SU1.6c5a3be1.png";